import React from 'react'
import Icon from '../Text/Icon'
import Text from '../Text/Text'

const TYPE_ICON={
    info: {icon:'info-circle',color:'text-primary'},
    success: {icon:'check-circle',color:'text-green-500'},
    warning: {icon:'exclamation-triangle',color:'text-yellow-500'},
    error: {icon:'x-circle',color:'text-red-500'},
    invite: {icon:'person-plus',color:'text-primary'},
}

function formatTime(ts) {
    if(!ts) return ''
    const diff=Date.now()-ts
    const mins=Math.floor(diff/60000)
    if(mins<1) return 'just now'
    if(mins<60) return `${mins}m ago`
    const hrs=Math.floor(mins/60)
    if(hrs<24) return `${hrs}h ago`
    return new Date(ts).toLocaleDateString()
}

export default function NotificationPanel({notifications,onMarkRead,onMarkAllRead,onDelete,onClose}) {
    return (
        <div className='absolute right-0 top-full z-50 mt-2 w-80 rounded-xl shadow-xl bg-white border border-gray-200 overflow-hidden'>
            <div className='flex items-center justify-between px-4 py-3 border-b border-gray-100'>
                <span className='font-semibold text-sm text-dark'>Notifications</span>
                <div className='flex items-center gap-2'>
                    <button onClick={onMarkAllRead} className='text-xs text-primary hover:underline'>Mark all read</button>
                    <button onClick={onClose} className='p-1 rounded hover:bg-gray-100 transition-colors'>
                        <Icon icon='x' className='text-sm text-gray-400' />
                    </button>
                </div>
            </div>
            <div className='max-h-80 overflow-y-auto divide-y divide-gray-50'>
                {notifications.length===0?(
                    <p className='py-8 text-center text-sm text-gray-400'>No notifications yet</p>
                ):notifications.map(n=>{
                    const {icon,color}=TYPE_ICON[n.type]||TYPE_ICON.info
                    return (
                        <div
                            key={n.id}
                            onClick={()=>!n.read&&onMarkRead(n.id)}
                            className={`flex items-start gap-3 px-4 py-3 transition-colors cursor-pointer ${n.read?'bg-white':'bg-blue-50 hover:bg-blue-100'}`}
                        >
                            <Icon icon={icon} className={`mt-0.5 text-base flex-shrink-0 ${color}`} />
                            <div className='flex-1 min-w-0'>
                                <p className='text-sm font-semibold text-dark truncate'>{n.title}</p>
                                <p className='text-xs text-gray-500 mt-0.5 line-clamp-2'>{n.body}</p>
                                <p className='text-[10px] text-gray-400 mt-1'>{formatTime(n.createdAt)}</p>
                            </div>
                            <button
                                onClick={e=>{e.stopPropagation();onDelete(n.id)}}
                                className='flex-shrink-0 p-0.5 rounded hover:bg-gray-200 transition-colors'
                            >
                                <Icon icon='x' className='text-xs text-gray-300 hover:text-gray-500' />
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
